import React from 'react';

import Embed from '../common/Embed.jsx';

function VideoComponent(props) {
    let url;
    if (props.blockConfig && props.blockConfig.block) {
        url = props.blockConfig.block.url;
        var youRegex = /^http[s]?:\/\/(((www.youtube.com\/watch\?(feature=player_detailpage&)?)v=)|(youtu.be\/))([^#\&\?]*)/;
        var vimeoRegex = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/)|(video\/))?([0-9]+)\/?/;
        var vimeoPrivateRegex = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/)|(video\/))?([0-9]+)\/([0-9A-z]+)\/?/;
        var youRegexMatches = youRegex.exec(url);
        var vimeoRegexMatches = vimeoRegex.exec(url);
        var viemoPrivateRegexMatches = vimeoPrivateRegex.exec(url);
        if (youRegexMatches != null || vimeoRegexMatches != null || viemoPrivateRegexMatches != null) {
            if (youRegexMatches != null && youRegexMatches.length >= 7) {
                var youMatch = youRegexMatches[6];
                url = '//www.youtube.com/embed/' + youMatch + '?rel=0';
            }
            else if (viemoPrivateRegexMatches != null && viemoPrivateRegexMatches.length >= 7) {
                var vimeoMatch = viemoPrivateRegexMatches[6];
                var vimeoPrivateMatch = viemoPrivateRegexMatches[7];
                url = '//player.vimeo.com/video/' + vimeoMatch + '?h=' + vimeoPrivateMatch;
            }
            else if (vimeoRegexMatches != null && vimeoRegexMatches.length >= 7) {
                var vimeoMatch = vimeoRegexMatches[6];
                url = '//player.vimeo.com/video/' + vimeoMatch;
            }
        }
    }
    return <Embed.Component {...props} className="video__cont" embedType="video" url={url} />
}

export default { Component: VideoComponent };